// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgCardLock = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.25 7A2.75 2.75 0 0 1 4 4.25h16A2.75 2.75 0 0 1 22.75 7v6a.75.75 0 0 1-1.5 0V9.75H6a.75.75 0 0 1 0-1.5h15.25V7c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10a.75.75 0 0 1 0 1.5H4A2.75 2.75 0 0 1 1.25 17z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.548 15.232c.383-.557 1.025-.982 1.952-.982s1.57.425 1.952.982c.355.518.465 1.114.465 1.518v1.102c.489.203.833.685.833 1.248v2.3a1.35 1.35 0 0 1-1.35 1.35h-3.8a1.35 1.35 0 0 1-1.35-1.35v-2.3c0-.563.344-1.045.833-1.248V16.75c0-.404.11-1 .465-1.518m1.035 2.518h1.834v-1c0-.179-.057-.458-.202-.67-.118-.171-.309-.33-.715-.33s-.597.159-.715.33c-.145.212-.202.491-.202.67zm-.833 1.5v2h3.5v-2z"
      clipRule="evenodd"
    />
  </svg>
);
export const CardLockIcon = forwardRef(SvgCardLock);
